import { BaseUseCase } from "@domains/useCases/UseCaseBase";
class EmailReportUsecase extends BaseUseCase {
    constructor(downloadRepo) {
        super();
        this.downloadRepo = downloadRepo;
    }
    async fetchResult(req) {
        return await this.downloadRepo.emailRevampReport(req);
    }
}
export default EmailReportUsecase;
